import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import IconSvg from 'components/Core/IconSvg';

const SocialShareBar = ({ socialShareTitle, articleTitle }) => {
  const encodedTitle = encodeURIComponent(articleTitle);
  const [location, setLocation] = useState('');

  // use effect to get window variable because we use SSR
  useEffect(() => {
    setLocation(encodeURIComponent(window.location));
  }, []);

  return (
    <div className="flex -mx-2">
      <div className="px-2">{socialShareTitle}</div>
      <div className="flex">
        <a
          className="px-2"
          href={`https://twitter.com/intent/tweet?url=${location}&text=${encodedTitle}`}
          rel="noreferrer"
          target="_blank"
        >
          <span className="sr-only">Delen via Twitter</span>
          <IconSvg className="text-primary" aria-hidden="true" icon="social-twitter" />
        </a>
        <a
          className="px-2"
          href={`https://www.facebook.com/sharer/sharer.php?u=${location}`}
          target="_blank"
          rel="noreferrer"
        >
          <span className="sr-only">Delen via Facebook</span>
          <IconSvg className="text-primary" aria-hidden="true" icon="social-facebook" />
        </a>
        <a
          className="px-2"
          href={`https://api.whatsapp.com/send?text=Bekijk+op+sportfondsen.nl%3A+${location}`}
          rel="noreferrer"
          target="_blank"
        >
          <span className="sr-only">Delen via Whatsapp</span>
          <IconSvg className="text-primary" aria-hidden="true" icon="social-whatsapp" />
        </a>
      </div>
    </div>
  );
};

SocialShareBar.propTypes = {
  socialShareTitle: PropTypes.string,
  articleTitle: PropTypes.string.isRequired,
};

SocialShareBar.defaultProps = {
  socialShareTitle: 'Delen:',
};

export default SocialShareBar;
